import React, { useEffect, useState } from 'react';
import './SiteRedirect.css';
import logo from '../assets/Zenio+Logo+header.png';
import backgroundImage from '../assets/mainloginBG.png';

function SiteRedirect() {
  const [countdown, setCountdown] = useState(3);
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    // Get site data from localStorage
    const storedData = localStorage.getItem('redirect_site_data');
    
    console.log('SiteRedirect loaded, checking localStorage...');
    console.log('Stored data:', storedData);
    
    if (!storedData) {
      console.error('No site data found in localStorage');
      // Wait a bit before redirecting to give time for debugging
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
      return;
    }

    try {
      const siteInfo = JSON.parse(storedData);
      console.log('Parsed site info:', siteInfo);
      setSiteData(siteInfo);
      // Don't remove data yet - wait until we use it
    } catch (error) {
      console.error('Error parsing site data:', error);
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
      return;
    }

  }, []);

  useEffect(() => {
    if (!siteData) return;

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Clear the localStorage now that we're done
          localStorage.removeItem('redirect_site_data');
          // Redirect to the actual site in new tab
          const newWindow = window.open(siteData.url, '_blank');
          
          // If popup was blocked, navigate in same window
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = siteData.url;
          } else {
            // Wait a moment for the new tab to open, then go back
            setTimeout(() => {
              window.history.back();
            }, 500);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [siteData]);

  const handleSkip = () => {
    if (siteData) {
      // Clear the localStorage before leaving
      localStorage.removeItem('redirect_site_data');
      window.open(siteData.url, '_blank');
      window.history.back();
    }
  };

  const handleGoBack = () => {
    // Clear the localStorage before leaving
    localStorage.removeItem('redirect_site_data');
    window.history.back();
  };

  if (!siteData) {
    return (
      <div className="site-redirect">
        <div className="redirect-container">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    
    <div className="site-redirect" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div class="loader-wrapper">
        <div className="redirect-container">
                <div className="redirect-header">
                  <img src={logo} alt="ZenIO Logo" className="zenio-logo" />
                </div>

                <div className="redirect-body">
                  <div className="redirect-icon-wrapper">
                    <div className="icon-display">
                      {siteData.icon === 'placeholder' ? (
                        <div className="placeholder-icon-large">{siteData.name.charAt(0)}</div>
                      ) : (
                        <img src={siteData.icon} alt={siteData.name} className="site-icon-large" />
                      )}
                    </div>
                  </div>

                  <h2 className="redirect-title">Redirecting to {siteData.name} in</h2>
                  <h1 className="redirect-count">{countdown}{countdown !== 1 ? '' : ''}</h1>

                  <div className="redirect-actions">
                    <button onClick={handleSkip} className="skip-button">
                      Go Now
                    </button>
                    <button onClick={handleGoBack} className="back-button">
                      Go Back
                    </button>
                  </div>
                </div>
        </div>
        <div class="loader"></div>
      </div>

      
    </div>
  );
}

export default SiteRedirect;